import React from 'react';
import { Button } from './Button';
export function HeroSection() {
  return <section className="bg-navy-dark text-white-soft pt-20 pb-24 px-6 md:px-12 relative overflow-hidden" data-id="element-120">
      {/* Subtle background pattern/glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[800px] bg-navy rounded-full blur-[120px] opacity-50 pointer-events-none" data-id="element-121"></div>

      <div className="max-w-5xl mx-auto relative z-10 flex flex-col md:flex-row items-center gap-12" data-id="element-122">
        <div className="flex-1 text-center md:text-left" data-id="element-123">
          <div className="inline-block px-4 py-1.5 rounded-full bg-gold/20 text-gold font-medium text-sm mb-6 border border-gold/30" data-id="element-124">
            Para personas de 50+ años
          </div>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white-soft mb-6 leading-tight" data-id="element-125">
            Protege tu Legado Digital:{' '}
            <span className="text-gold block mt-2" data-id="element-126">
              Guía de Paz Mental para tu Familia
            </span>
          </h1>
          <p className="text-xl md:text-2xl text-gray-300 mb-10 font-light leading-relaxed max-w-2xl" data-id="element-127">
            El sistema de 3 pasos para asegurar tus cuentas, fotos y ahorros sin
            complicaciones técnicas (y sin revelar tus claves hoy).
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center md:justify-start" data-id="element-128">
            <Button onClick={() => document.getElementById('offer')?.scrollIntoView({
            behavior: 'smooth'
          })} data-id="element-129">
              ¡SÍ, QUIERO PROTEGER A MI FAMILIA AHORA!
            </Button>
          </div>
          <div className="mt-6 flex items-center justify-center md:justify-start gap-2 text-sm text-gray-400" data-id="element-130">
            <span className="flex items-center" data-id="element-131">⭐ ⭐ ⭐ ⭐ ⭐</span>
            <span data-id="element-132">Garantía de satisfacción 100%</span>
          </div>
        </div>

        <div className="flex-1 w-full max-w-md relative" data-id="element-133">
          <div className="absolute inset-0 bg-gold/20 rounded-2xl blur-2xl transform rotate-3" data-id="element-134"></div>
          <img src="https://cdn.magicpatterns.com/uploads/4R2ZHCBpcWG1Cvo2qAPAWf/Legado_Digital.png" alt="Legado Digital Seguro en iPad" className="relative z-10 w-full h-auto rounded-xl shadow-2xl border border-white/10" data-id="element-135" />
        </div>
      </div>
    </section>;
}